import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { MaybeRef } from 'vue';

export const accountManager = createQueryKeys('accountManager', {
  // Keyed by UI locale: guests get a language-aware public AM (e.g. Hebrew → a Hebrew-speaking AM).
  current: (locale: string) => [locale],
  // Whether the signed-in AM is a team lead (ID-156).
  teamMe: null,
  // "Find user → Payment link" search (ID-181).
  paymentLinkUsers: (q: MaybeRef<string>) => [q],
  // The signed-in AM's code for invite links (referral and/or assign-to-me).
  inviteLinkCode: null,
});
